const apiVersion = 'v1';
const apiBaseUrl = process.env.SGMR_DATA_API_BASE_URL || 'http://localhost:5000';

export const apiUrl = `${apiBaseUrl}/${apiVersion}`;

// Flags for showing site maintenance and notifications
const isEnabled = (value) =>
  typeof value === 'string' ? value.toLowerCase() === 'true' : value === true;

export const showSiteMaintenance = isEnabled(process.env.SGMR_MAINTENANCE);
export const siteMaintenanceText = process.env.SGMR_MAINTENANCE_TEXT || '';

export const showNotification = isEnabled(process.env.SGMR_NOTIFICATION);
export const notificationText = process.env.SGMR_NOTIFICATION_TEXT || '';

export const feedbackUrl = process.env.FEEDBACK_URL;
export const ga4MeasurementId = process.env.GA_MEASUREMENT_ID;
export const oneLoginClientId = process.env.ONELOGIN_CLIENT_ID || 'z62AIFlQJEMnEpyCz-O8xeUBAY8';
export const oneloginUrl = process.env.ONELOGIN_URL || 'https://oidc.integration.account.gov.uk';
export const oneloginRedirectUrl =
  process.env.ONELOGIN_REDIRECT_URL || 'http://localhost:8080/login-redirect';
export const oneloginPostLogouturl =
  process.env.ONELOGIN_POST_LOGOUT_URL || 'http://localhost:8080';
export const oneloginSecurityUrl =
  process.env.ONELOGIN_SECURITY_URL || 'https://home.integration.account.gov.uk/security';
